import { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';

import { APP_VERSION_CACHE_KEY, FILTERS_CACHE_KEY } from 'shared/consts';
import { LocalStorage } from 'tools';

const useAppNewVersion = () => {
  const [isNewVersion, setIsNewVersion] = useState(false);

  const fetchVersion = useCallback(async () => {
    const resp = await fetch('/index.html', {
      method: 'get',
      mode: 'cors',
    });

    const htmlText = await resp.text();

    const regex =
      /<script\s+type="module"\s+crossorigin\s+src="\/assets\/index-(.+)\.js"><\/script>/;
    const match = htmlText.match(regex);

    return match ? match[1] : '';
  }, []);

  const checkVersion = useCallback(async () => {
    const appVersion = LocalStorage.get(APP_VERSION_CACHE_KEY);
    const currentVersion = await fetchVersion();

    if (appVersion !== currentVersion && !isNewVersion) {
      LocalStorage.remove(APP_VERSION_CACHE_KEY);
      LocalStorage.remove(FILTERS_CACHE_KEY);
      LocalStorage.set(APP_VERSION_CACHE_KEY, currentVersion);

      toast.info('New version available, refresh the app', {
        action: {
          label: 'Refresh',
          onClick: () => window.location.reload(),
        },
        duration: Infinity,
      });
      setIsNewVersion(true);
    }
  }, [fetchVersion, isNewVersion]);

  useEffect(() => {
    // Initial check on mount
    checkVersion();

    // Set up interval to check every 30 seconds
    const intervalId = setInterval(checkVersion, 60e3);

    // Cleanup interval on unmount
    return () => {
      clearInterval(intervalId);
    };
  }, [checkVersion]);
};

export { useAppNewVersion };
